import Vue from 'vue'
import { Component, Mixins, Ref } from 'vue-property-decorator'
import { uGetDateFormat } from '@appbase/util';
import api from '@webparts/api/graph';

import UserCardComponent from '@appbase/components/common/UserCard/UserCardComponent';

@Component({

})
export default class FileList extends UserCardComponent {
    @Ref('refDivScroll') scrollDiv!: HTMLElement;

    fileImages: {  [key: string]: any } = {
        'xls': require('@webparts/assets/file_excel.png'),
        'xlsx': require('@webparts/assets/file_excel.png'),
        'ppt': require('@webparts/assets/file_ppt.png'),
        'pptx': require('@webparts/assets/file_ppt.png'),
        'docx': require('@webparts/assets/file_word.png'),
        'doc': require('@webparts/assets/file_word.png'),
        'none': require('@webparts/assets/file_nonoffice.png')
    }

    recentFiles: graph.DriveItem[] = [];
    currentPage: number = 0;
    filesPerPage: number = 20;
    onLoadMore: boolean = false;
    reachingEnd: boolean = false;

    mFiles: graph.DriveItem[] = [];
    mFileParentInfos: graph.DriveItem[] = [];

    getParentPath(parentId: string) {
        let parentInfo = this.mFileParentInfos.find(pi => pi.id === parentId);
        let rootPath = parentInfo?.parentReference.name ?? ''
        let foldername = parentInfo?.name ?? ''
     
        if(foldername === 'root') {
            return '내 문서'
        } else if (foldername.length > 0) {
            return `${rootPath} > ${foldername}`;
        } else {
            return '';
        }     
    }

    fileImage(fileName: string) {
        let extension = fileName.split('.').pop() ?? '';    
        extension = Object.keys(this.fileImages).findIndex(i => i === extension.toLowerCase()) >= 0 ?
            extension.toLowerCase() : 'none'; 

        return this.fileImages[extension];
    }

    modifiedDisplayTime(modified: string) {      
        return uGetDateFormat('yyyy-MM-dd H:i:s', new Date(modified));
    }

    loadMore() {
        if(!(this.onLoadMore || this.reachingEnd)) {
            this.onLoadMore = true;
            setTimeout(() => {
                this.currentPage += 1;
                let append = this.getPage(this.currentPage);
                this.mFiles = [
                    ...this.mFiles,
                    ...append
                ]            
                
                this.loadFilePath(append);
                this.onLoadMore = false;
            }, 1000);                   
        }        
    }

    loadFilePath(items: graph.DriveItem[]): Promise<graph.DriveItem[]> {
        var infoRequest: graph.DriveItemsRequet = {
            items: items.map(f => <graph.DriveItemRequest>{ 
                driveId: f.parentReference.driveId,
                itemId: f.parentReference.id
            })
        }

        return api.getDriveItems(infoRequest).then(res => {
            this.mFileParentInfos = [
                ...this.mFileParentInfos,
                ...res
            ]
            return res;
        });
    }

    getPage(page: number): graph.DriveItem[] {
        let startIdx = (page - 1) * this.filesPerPage;
        let endIdx = page * this.filesPerPage;  
        
        if(endIdx >= (this.recentFiles.length - 1)) {
            this.reachingEnd = true;
        }

        return this.recentFiles.slice(startIdx, endIdx);
    }

    onOpenFile(file: graph.DriveItem) {
        window.open(file.webUrl);
    }

    onScroll(e: any) {
        if(this.scrollDiv) {
            if(this.scrollDiv.offsetHeight + this.scrollDiv.scrollTop >= this.scrollDiv.scrollHeight) {
                this.loadMore();
            }            
        }        
    }

    mountAction() {        
        api.getRecentFiles().then(res => {
            this.recentFiles = res.sort((a, b) => {
                let aTime = (new Date(a.lastModifiedDateTime)).getTime();
                let bTime = (new Date(b.lastModifiedDateTime)).getTime();
                return bTime - aTime;
            });           
      
            let pageItems = this.getPage(1);
            this.mFiles = pageItems; 
            this.currentPage = 1;              
            this.$emit('mounted');
            this.loadFilePath(pageItems);
        })                                      
    }

    created() {
        this.mountAction();
    }
}